import React from "react"
import { connect, useDispatch } from "react-redux"
import { State } from "../../../../../../Reducers"
import { KeysModal } from "./KeysModal/KeysModal"
import { ModalViewName, ModalView } from "../../../../../../Models/Client/Modal"
import { UserBilling } from "../../User/Billing/Billing"
import { AskIfReviewJobOutput } from "../../../../../Common/Modal/AskIfReviewJobOutput"
import { ContactForm } from "../../../../../Common/Modal/ContactForm"
import { closeModal } from "../../../../../../Actions/Client/ModalActions"

interface DashboardModalProps {
    id?: string
}

interface StateProps {
    view?: ModalView
}

interface DispatchProps {}

export type Props = DashboardModalProps & StateProps & DispatchProps

export const DashboardModalIsolated = ({ id, view }: Props) => {
    const dispatch = useDispatch()
    const handleClose = () => dispatch(closeModal())

    if (view === undefined) return <></>

    switch (view.type) {
        case ModalViewName.keys:
            return <KeysModal />
        case ModalViewName.billing:
            return <UserBilling />
        case ModalViewName.askIfReviewJobOutput:
            return <AskIfReviewJobOutput />
        case ModalViewName.contactForm:
            return <ContactForm {...view} onClose={handleClose} />
        default:
            return <></>
    }
}

const mapStateToProps = (state: State): StateProps => {
    return {
        view: state.client.modal.view
    }
}

export const DashboardModal = connect(
    mapStateToProps,
    null
)(DashboardModalIsolated)
